import { render, staticRenderFns } from "./WhyChoose.vue?vue&type=template&id=9858651c&scoped=true"
import script from "./WhyChoose.vue?vue&type=script&lang=js"
export * from "./WhyChoose.vue?vue&type=script&lang=js"
import style0 from "./WhyChoose.vue?vue&type=style&index=0&id=9858651c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9858651c",
  null
  
)

export default component.exports